import { gql } from '@apollo/client';

export const GET_REFERRALS_CONFIG = gql`
  query get_referrals_config {
    get_referrals_config {
      hasError
      message
      data
    }
  }
`;

export interface StripeAccount {
  id: string;
  details_submitted: boolean;
  charges_enabled: boolean;
  payouts_enabled: boolean;
}

export interface ReferralsConfig {
  account: StripeAccount;
  loginLink: string;
  needsOnboarding: boolean;
}

export interface GetReferralsConfigResponse {
  get_referrals_config: {
    hasError: boolean;
    message: string;
    data: ReferralsConfig;
  };
}
